module.exports = __webpack_public_path__ + "img/level_normal.3cf09172.png";